import axios from 'axios';

import routes from 'app/routes';

export default {
  sendMessage: (chatId, values, successCallback, errorCallback) => {
    const formData = new FormData();

    Object.keys(values).forEach((key) => {
      formData.append(key, values[key] === null ? '' : values[key]);
    });

    axios
      .post(routes.api.session_rooms.messages.create(chatId), formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((_resp) => {
        successCallback();
      }).catch((error) => {
        const { data } = error.response;
        if (data.errors) {
          const errors = data.errors.map((item) => item.detail);
          errorCallback(errors.join(' '));
        }
      });
  },
  readMessage: (chatId, messageId) => axios
    .put(routes.api.session_rooms.messages.update(chatId, messageId), {
      read: true,
    })
    .then((_resp) => true).catch((_error) => false),

  archiveChat: (chatId, callback) => axios
    .post(routes.api.session_rooms.archive(chatId))
    .then(() => callback()).catch(() => callback()),

};
